import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { Provider } from "react-redux";

import App from "./containers/App/App";
import { store } from "./redux/store/index";

import * as serviceWorkerRegistration from './serviceWorkerRegistration';

import { Toaster } from 'react-hot-toast';
import "./index.css"
import "animate.css"
import OrdersNotification from "./components/OrdersNotification/OrdersNotification";


createRoot(document.getElementById("app")).render(
  <React.StrictMode>
    <Provider store={store}>
      <Router>
        <App />
        <OrdersNotification />
        <Toaster />
      </Router>
    </Provider>
  </React.StrictMode>
);


serviceWorkerRegistration.register();